export default {
    data(){
        return{
    en: {
      plan_and_cases_title: 'Plan and Cases',
      sectors : [
        { 
            name: 'film_television', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/FilmTelevision.jpg'),
            displayName: 'Film and Television', 
            class: 'film_television', 
            show: false ,
            description:'description',
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/CultureTour.jpg'),
            displayName: 'Culture Tour', 
            class: 'culture_tour', 
            show: false,
            description:'description',
          },
          { 
            name: 'digital_assets',
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DigitalAssets.png'),
            displayName: 'Digital Assets', 
            class: 'digital_assets', 
            show: false,
            description:'description',
          },
          { 
            name: 'aigc', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/AIGC.png'),
            displayName: 'AIGC', 
            class: 'aigc', 
            show: false,
            description:'description',
          },
            // Add more sectors as needed
      ],
      
      dropdown_sectors : [
        // film_television
          { 
            name: 'film_television', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/FilmTelevision_DreamWater.jpg'),
            displayName: 'Virtual Film-making: Sea of Dreams', 
            displaySectionName: 'Film and Television', 
            class: 'film_television', 
            show: false ,
            description:
                'Provided virtual production technical support to the cast and crew of "Sea of Dreams" for virtual filming of scripted scenes, such as space glaciers and apocalyptic wastelands',
            DetailFolderName: 'filmAndTelevision', 
            DetailPageName: "DreamWaterPage"  
          },
          // 根据敬基的需求，暂时不需要白蛇这个案例
        // digital_assets
          { 
            name: 'digital_assets', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/DigitalAssets_BeijiaoPictureWallOpacity.png'),
            displayName: `Beijing Jiaotong University's Digital Museum`, 
            displaySectionName: 'Digital Assets',
            class: 'digital_assets', 
            show: false,
            description:
                `In July 2023, Beijing Jiaotong University's Transportation Equipment Teaching Hall started to move, Rosy Nebula used a combination of reverse and forward modelling to successfully complete the digital modelling of the exhibits and successfully completed the project.`,
            DetailFolderName: 'digitalAssets',     
            DetailPageName: "BeijiaoDigitalMuseumPage"
          },
          { 
            name: 'digital_assets',  
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/DigitalAssets_Ceramsite.png'),
            displayName: 'Unreal Engine-based Ceramsite factory production-process demo film', 
            displaySectionName: 'Digital Assets',
            class: 'digital_assets', 
            show: false,
            description:
                'The Rosy Nebula team created a CG animation for a Ceramsite panel factory, showing the details of the production process, product highlights and technical heritage.',
            DetailFolderName: 'digitalAssets',     
            DetailPageName: "CeramsiteFactoryPage"
          },
            // Add more dropdown as needed
      ],
      
      dropdown_sectors2 : [
        // culture_tour
          { 
            name: 'culture_tour',
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_LightShow.png'),
            displayName: 'Xiangshan Global Studios-Light Projection Show', 
            displaySectionName: 'Culture Tour',
            class: 'culture_tour', 
            show: false,
            description:
                'The ultra-realistic CG animation production based on the Unreal Engine which combines traditional dance performances with projection technology, presents a visual feast for visitors.',
            DetailFolderName: 'cultureTour',     
            DetailPageName: "CityWallProjectionPage"    
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_VRPark.jpg'),
            displayName: 'VR Park Fangte Venue, Ningbo', 
            displaySectionName: 'Culture Tour',
            class: 'culture_tour', 
            show: false,
            description:` VR Vidámpark's first family entertainment centre in China, an outstanding example of Sino-foreign cultural and tourism cooperation.`,
            DetailFolderName: 'cultureTour',    
            DetailPageName: "VRParkCasesPage"
          },
          { 
            name: 'culture_tour', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/CultureTour_VRParkNingboScience.jpeg'),
            displayName: 'Ningbo Science Exploration Centre: Fairy Tale', 
            displaySectionName: 'Culture Tour',
            class: 'culture_tour', 
            show: false,
            description:`Ningbo's first VR LBE large space theme museum, science exploration centre combining science and entertainment`,
            DetailFolderName: 'cultureTour',    
            DetailPageName: "VRParkNingboScience"
          },

          // 根据单靠的需求，暂时不需要AI绘画这个案例
        // aigc
          { 
            name: 'aigc', 
            image: require('@/assets/img/PlanandCases/PlanandCasesHome/DropDown/AIGC_MetaHumanShangguan.jpg'),
            displayName: 'Meta-Human', 
            displaySectionName: 'AIGC',
            class: 'aigc', 
            show: false,
            description:`Meta-Human Rosy Nebula's Meta-Human is not only capable of natural language interaction and basic emotion recognition, but also has a well-designed appearance that enables it to engage in a smooth dialogue with the user and adjust the dialogue strategy according to the user's emotions, providing the user with a good interactive experience.`,
            DetailFolderName: 'AIGC',
            DetailPageName: "BataHumanPage"
          },
            // Add more dropdown as needed
      ],
    }
}
}
  };
  